(function(){
var R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
document.querySelectorAll('.lvsc').forEach(function(root){
  var form=root.querySelector('form.ff');
  function go(params){
    params.delete('page');
    var q=params.toString();
    location.href=location.pathname+(q?'?'+q:'');
  }
  function fromForm(){
    var p=new URLSearchParams();
    new FormData(form).forEach(function(v,k){ if(String(v).trim()!=='') p.append(k,v); });
    var cur=new URLSearchParams(location.search); if(cur.get('q')) p.set('q',cur.get('q'));
    return p;
  }
  if(form){
    form.addEventListener('change',function(){ go(fromForm()); });
    form.addEventListener('submit',function(e){ e.preventDefault(); go(fromForm()); });
  }
  var sel=root.querySelector('.so select');
  if(sel) sel.addEventListener('change',function(){ var p=new URLSearchParams(location.search); p.set('sort_by',sel.value); go(p); });
  root.querySelectorAll('[data-more]').forEach(function(b){
    b.dataset.lbl=b.textContent;
    b.addEventListener('click',function(){ var ul=b.previousElementSibling; ul.classList.toggle('all'); b.textContent=ul.classList.contains('all')?'Sýna færri':b.dataset.lbl; });
  });
  var fb=root.querySelector('.fbtn'), x=root.querySelector('.side .x'), ov=root.querySelector('.lvsc-ov');
  function tog(o){ root.classList.toggle('open',o); document.documentElement.style.overflow=o?'hidden':''; }
  if(fb) fb.addEventListener('click',function(){tog(true);});
  if(x) x.addEventListener('click',function(){tog(false);});
  if(ov) ov.addEventListener('click',function(){tog(false);});

  function setCount(n){
    document.querySelectorAll('a[href="'+R+'cart"]').forEach(function(a){
      var c=a.querySelector('.cnt');
      if(!c){ c=document.createElement('span'); c.className='cnt'; a.appendChild(c); }
      c.textContent=n;
    });
  }
  function label(p){ return 'Setja í körfu · <span data-p>'+p+'</span>'; }
  root.addEventListener('click',function(e){
    var s=e.target.closest('.sz button');
    if(s && !s.disabled){
      var card=s.closest('.cd');
      card.querySelectorAll('.sz button').forEach(function(b){ b.classList.remove('on'); b.setAttribute('aria-checked','false'); });
      s.classList.add('on'); s.setAttribute('aria-checked','true');
      var add=card.querySelector('[data-add]');
      if(add){ add.dataset.add=s.dataset.id; add.classList.remove('ok'); add.innerHTML=label(s.dataset.price); }
      return;
    }
    var a=e.target.closest('[data-add]');
    if(a && !a.disabled){
      a.disabled=true;
      fetch(R+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(a.dataset.add),quantity:1}]})})
        .then(function(r){ if(!r.ok) throw r; return fetch(R+'cart.js'); })
        .then(function(r){ return r.json(); })
        .then(function(c){ setCount(c.item_count); a.classList.add('ok'); a.innerHTML='Komið í körfu ✓'; a.disabled=false;
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          setTimeout(function(){ if(a.classList.contains('ok')){ var on=a.closest('.cd').querySelector('.sz button.on'); a.classList.remove('ok'); a.innerHTML=label(on?on.dataset.price:''); } },2600); })
        .catch(function(){ a.disabled=false; a.innerHTML='Villa – reyndu aftur'; });
    }
  });

  var more=root.querySelector('[data-next]');
  if(more) more.addEventListener('click',function(e){
    e.preventDefault(); if(more.classList.contains('ld')) return;
    more.classList.add('ld');
    fetch(more.href).then(function(r){return r.text();}).then(function(h){
      var d=new DOMParser().parseFromString(h,'text/html');
      var src=d.getElementById(root.id); if(!src){ location.href=more.href; return; }
      var grid=root.querySelector('.grid');
      src.querySelectorAll('.grid > .cd').forEach(function(c){ grid.appendChild(c); });
      var shown=root.querySelector('[data-shown]'); if(shown) shown.textContent=grid.querySelectorAll('.cd').length;
      var nx=src.querySelector('[data-next]');
      if(nx){ more.href=nx.href; more.classList.remove('ld'); } else { more.parentNode.remove(); }
    }).catch(function(){ location.href=more.href; });
  });
});
})();